<template>
  <div class="border border-solid border-gray rounded p-4 flex justify-between items-center hover:border-focus hover:cursor-pointer"
       :class="bubbleClasses"
       @click="$emit('click')">
    <span>{{ label }}</span>
    <feather-icon v-if="isProductRecommendation" icon="ShoppingBagIcon" svg-classes="h-6 w-6"/>
    <GPT-icon v-else class="h-6 w-6" />
  </div>
</template>

<script>
import GPTIcon from '@/assets/images/icons/GPTIcon.vue'

export default {
  name: 'ChatGPTActionPlaceholder',

  components: { GPTIcon },

  props: {
    label: { type: String, default: 'AI answer' },
    isProductRecommendation: { type: Boolean, default: false },
    focus: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },

  computed: {
    bubbleClasses() {
      if (this.error) return 'border-focus-error text-focus-error'
      return this.focus ? 'border-focus bubble-shadow text-gray-dark' : 'text-gray-dark'
    }
  }
}
</script>

<style lang="scss" scoped>
.bubble-shadow {
  box-shadow: 0 4px 11px 0 theme('colors.focus-a50');
}
</style>
